import { Chip, styled } from '@mui/material';

import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';

const CustomChip = styled(Chip)(({ theme, type }) => ({
	fontWeight: 500,
	fontSize: 13,
	minWidth: 110,
	color: type === 'sale' ? 'rgb(70, 170, 10)' : (type === 'return' ? 'rgb(250, 10, 10)' : 'rgb(245, 182, 10)'),
	backgroundColor: type === 'sale' ? 'rgba(70, 170, 10, 0.15)' : (type === 'return' ? 'rgba(250, 10, 10, 0.15)' : 'rgba(245, 182, 10, 0.15)'),
}));

const CustomChipSelected = styled(Chip)(({ theme, type }) => ({
	fontWeight: 500,
	fontSize: 13,
	minWidth: 110,
	color: type === 'sale' ? 'rgba(70, 170, 10, 0.7)' : (type === 'return' ? 'rgba(250, 10, 10, 0.7)' : 'rgba(245, 182, 10, 0.7)'),
	border: '1px solid',
	backgroundColor: 'transparent',
}));

const config = {
	sale: {
		icon: <PaidOutlinedIcon fontSize="small" />,
		type: 'sale'
	},
	return: {
		icon: <RefreshRoundedIcon fontSize="small" />,
		type: 'return'
	},
	purchase: {
		icon: <ShoppingCartOutlinedIcon fontSize="small" />,
		type: 'purchase'
	}
}

export { CustomChip, CustomChipSelected, config }